import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { SplitText } from '@/components/motion/split-text'

interface SectionHeadingProps {
    lead: string
    title: string
    align?: 'left' | 'right'
    as?: 'h1' | 'h2'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    lead,
    title,
    align = 'left',
    as = 'h2',
    className
}): ReactNode => {
    const Tag = as

    return (
        <Tag
            aria-label={`${lead} ${title}`}
            className={cn(
                'flex w-full flex-col py-6 text-foreground mix-blend-screen',
                align === 'right' ? 'items-end pl-6 text-right' : 'items-start pr-6 text-left',
                className
            )}
        >
            <SplitText
                text={lead}
                effect='fade'
                stagger={0.04}
                accessible={false}
                className='t-mega-serif block w-full'
            />

            {' '}

            <SplitText
                text={title}
                effect={align === 'right' ? 'slide-left' : 'slide'}
                stagger={0.03}
                accessible={false}
                className='t-mega block w-full'
            />
        </Tag>
    )
}
